import React, { useEffect, useState } from "react";

import Modal from "react-bootstrap/Modal";

import { useNavigate, useLocation } from "react-router-dom";

import Button from "../global/button";
import { sortOptions } from "./sortOptions";

import { ReactComponent as SortIcon } from "../../assets/sort.svg";

const ListingSortModal = ({
  handleSort: paramHandleSort,
  selectedSort: paramSelectedSort,
}) => {
  const [selectedSort, setSelectedSort] = useState(paramSelectedSort || "");
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  function handleSort() {
    if (selectedSort === "") return;

    paramHandleSort(selectedSort);
    setShow(false);
  }

  function handleClear() {
    setSelectedSort("");

    const search = location.search;

    const _search = search.replace(/&sortType=\w+/, ``);
    setShow(false);
    navigate(`/properties${_search}`);
  }

  useEffect(() => {
    setSelectedSort(paramSelectedSort);
  }, [paramSelectedSort]);

  return (
    // here i am using same classnames in the filter popup
    <>
      <button aria-expanded={show} onClick={() => setShow(true)}>
        Sort <SortIcon />
      </button>

      <Modal
        className="property-sort-modal"
        show={show}
        onHide={() => {
          setShow(false);
        }}
        backdrop="true"
        keyboard={true}
        size="md"
        aria-labelledby="Property Sort Modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Sort by</Modal.Title>
          <Button
            variant="secondary"
            size="sm"
            className="clear-btn"
            onClick={handleClear}
          >
            Clear
          </Button>
        </Modal.Header>
        <Modal.Body>
          {sortOptions.map((item, index) => {
            return (
              <button
                type="button"
                className="property-sort-item"
                key={index}
                data-selected={selectedSort === item.value}
                onClick={() => setSelectedSort(item.value)}
                data-disabled={item.isDisabled}
              >
                {item.label}
              </button>
            );
          })}

          <Button className="sort-button" onClick={handleSort}>
            Sort
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ListingSortModal;
